<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">WAIVED BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Waived Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Card -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card bg-warning text-dark">
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-8">
                        <h5 class="text-dark mb-1">Total Waived Amount</h5>
                        <h2 class="text-dark mb-0">{{ totalDetailAmount }}</h2>
                        <small class="text-dark opacity-75">Bills with approved waivers</small>
                      </div>
                      <div class="col-4 text-end">
                        <div class="badge bg-dark text-warning fs-6 px-3 py-2">
                          {{ numberFormat(summary.count) }} Waived Bills
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">
                        <i class="mdi mdi-file-cancel-outline me-2 text-warning"></i>
                        All Waived Bills
                      </h4>
                      <div>
                        <a v-if="getRight('CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Search -->
                      <div class="col-md-4">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search bills, descriptions, customers...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>

                      <!-- Date Filters -->
                      <div class="col-md-3">
                        <label class="form-label mb-1">From Date:</label>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">To Date:</label>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>

                      <!-- Filter Options -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Filter By:</label>
                        <select class="form-select" v-model="filter">
                          <option value="filter-all">All Items</option>
                          <option value="filter-sub-county">Sub County</option>
                          <option value="filter-wards">Ward</option>
                          <option value="filer-zone">Zone</option>
                          <option value="filter-officer">Officer</option>
                        </select>
                      </div>
                    </div>

                    <!-- Filter Items Selection -->
                    <div class="row g-3 mt-2" v-if="filter !== 'filter-all'">
                      <div class="col-md-4">
                        <select class="form-select" v-model="selectedItem">
                          <option value="">Select {{ getFilterLabel() }}</option>
                          <option v-for="(item, index) in itemList" :key="index" :value="item.value">
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Download Buttons -->
                    <div class="mt-3">
                      <div class="btn-group" role="group">
                        <!-- Download Current Page -->
                        <button v-if="getRight('DOWNLOAD WAIVED INVOICES')"
                                @click="downloadCurrentPage()"
                                type="button"
                                class="btn btn-warning"
                                :disabled="billinfoWaiver.length === 0">
                          <i class="bx bxs-download font-size-16"></i>
                          <span class="ms-1">Current Page ({{ billinfoWaiver.length }})</span>
                        </button>

                        <!-- Download All Records with Progress -->
                        <button v-if="getRight('DOWNLOAD WAIVED INVOICES')"
                                @click="downloadAllRecords()"
                                type="button"
                                class="btn btn-dark"
                                :disabled="isDownloadingAll || summary.count === 0">
                          <span v-if="isDownloadingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Downloading...
                          </span>
                          <span v-else>
                            <i class="bx bx-cloud-download font-size-16"></i>
                            <span class="ms-1">Download All ({{ numberFormat(summary.count) }})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-warning">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap" style="min-width: 200px;">Description</th>
                          <th class="text-nowrap">Location</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Waived Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in billinfoWaiver" :key="index">
                          <td class="text-nowrap">{{ ((currentPage - 1) * pageSize) + index + 1 }}</td>
                          <td class="text-nowrap">
                            <span class="fw-semibold text-warning">{{ item.billNo }}</span>
                          </td>
                          <td style="min-width: 200px;">
                            <div>
                              <strong>{{ item.feeDescription }}</strong>
                              <small class="text-muted d-block">{{ item.description }}</small>
                              <div class="mt-1">
                                    <span class="badge bg-warning text-dark">
                                      <i class="mdi mdi-file-cancel-outline me-1"></i>WAIVED
                                    </span>
                              </div>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ item.subCountyName }}</div>
                              <small class="text-muted">{{ item.wardName }}</small>
                              <small class="text-muted d-block">{{ item.zone }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ item.names }}</td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold text-warning">{{ formatPrice(item.billTotal) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.receiptAmount) }}</span>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(item.billBalance) }}</span>
                          </td>
                          <td>
                                <span v-if="item.status === 'PAID'" class="badge bg-success text-uppercase">
                                  {{ item.status }}
                                </span>
                            <span v-else class="badge bg-danger text-uppercase">
                                  UNPAID
                                </span>
                          </td>
                          <td class="text-nowrap">{{ item.dateCreated }}</td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="getBill(item.billNo)"
                                      class="btn btn-outline-warning btn-sm me-2"
                                      data-bs-toggle="modal"
                                      data-bs-target="#waivedBillModal">
                                <i class="bx bx-show me-1"></i>View
                              </button>
                              <button v-if="getRight('REVERT WAIVER')"
                                      @click="revertWaiver(item.id)"
                                      class="btn btn-outline-danger btn-sm">
                                <i class="mdi mdi-backup-restore me-1"></i>Revert
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-warning">
                        <tr>
                          <th colspan="5" class="text-end">{{ billinfoWaiver.length }} Waived Bills</th>
                          <th class="text-end">{{ totalDetailAmount }}</th>
                          <th class="text-end">{{ totalReceiptAmount }}</th>
                          <th class="text-end">{{ totalBillBalance }}</th>
                          <th colspan="3"></th>
                        </tr>
                        </tfoot>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-warning mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Waived Bills</h4>
                        <p>We are fetching the waived bills data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="billinfoWaiver.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Waived Bills Found</h4>
                        <p>Sorry, we could not find any waived bills that match your search or filter criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                          <option value="150">150 Rows</option>
                          <option value="200">200 Rows</option>
                          <option value="500">500 Rows</option>
                          <option value="1000">1000 Rows</option>
                        </select>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-warning text-dark">
                <h5 class="modal-title text-dark">
                  <i class="bx bxs-download me-2"></i>Downloading All Waived Bills
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-warning mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                  <h5 v-else class="text-warning">Download Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ downloadProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped bg-warning"
                      :class="{'progress-bar-animated': !downloadPaused}"
                      role="progressbar"
                      :style="{ width: downloadProgress.percentage + '%' }"
                      :aria-valuenow="downloadProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ downloadProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                  <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ downloadError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the download.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ downloadRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!downloadPaused && !downloadError"
                      @click="pauseDownload"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="downloadPaused || downloadError"
                      @click="resumeDownload"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelDownload"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Download Statistics -->
                <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Downloaded</small>
                      <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Waived Bill Detail Modal -->
        <WaivedBillModal
            :billDetail="billDetail"
            :billInfo="billInfo"
            :billNo="billNo"
            @print-bill="printBill"
            @revert-waiver="handleRevertWaiver"
        />

        <!-- Alert for actions -->
        <div v-if="alert.success || alert.failed || alert.info" class="toast-container position-fixed top-0 end-0 p-3">
          <div class="toast show" role="alert">
            <div class="toast-header" :class="{
                'bg-success text-white': alert.success,
                'bg-danger text-white': alert.failed,
                'bg-info text-white': alert.info
              }">
              <strong class="me-auto">Notification</strong>
              <button type="button" class="btn-close" @click="clearAlerts"></button>
            </div>
            <div class="toast-body">
              {{ message }}
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import WaivedBillModal from "@/components/invoices/modals/WaivedBillModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "WaivedBills",
  components: {
    NavigationBar,
    WaivedBillModal
  },
  data() {
    return {
      download: 'Download',
      search: '',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,

      // Filters
      dateFrom: '',
      dateTo: '',
      filter: 'filter-all',
      selectedItem: null,

      // Data
      billinfoWaiver: [],
      billInfo: [],
      billDetail: {},
      billNo: '',

      // Filter data
      itemList: [],

      // Summary
      summary: { count: 0, total: 0 },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },
  computed: {
    totalReceiptAmount() {
      return this.formatPrice(this.billinfoWaiver.reduce((sum, item) => sum + parseInt(item.receiptAmount || 0), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billinfoWaiver.reduce((sum, item) => sum + parseInt(item.billBalance || 0), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billinfoWaiver.reduce((sum, item) => sum + parseInt(item.billTotal || 0), 0));
    }
  },
  watch: {
    pageSize() {
      this.getBills("");
      this.totalPages = Math.ceil(this.summary.count / this.pageSize);
      this.currentPage = 1;
    },
    search() {
      this.getBills(this.search);
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.getBills("");
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.getBills("");
      }
    },
    filter() {
      this.selectedItem = null;
      this.itemList = [];

      if (this.filter === 'filter-all') {
        this.getBills("");
      } else if (this.filter === 'filter-sub-county') {
        this.getSubCounties();
      } else if (this.filter === 'filter-wards') {
        this.getWards();
      } else if (this.filter === 'filer-zone') {
        this.getZones();
      } else if (this.filter === 'filter-officer') {
        this.getUsers();
      }
    },
    selectedItem() {
      if (this.selectedItem) {
        this.getBills(this.selectedItem);
      }
    }
  },
  mounted() {
    // Set default date range
    this.dateFrom = moment().subtract(1, 'month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    // Load initial data
    if (sessionStorage.getItem("keyword") === "") {
      this.getBills("");
    } else {
      this.getBills(sessionStorage.getItem("keyword"));
    }

    this.menuAccess();
  },
  methods: {
    getRight,

    // Utility methods
    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    gotTo(route) {
      router.push(route);
    },

    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto clear after 5 seconds
      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    getFilterLabel() {
      const labels = {
        'filter-sub-county': 'Sub County',
        'filter-wards': 'Ward',
        'filer-zone': 'Zone',
        'filter-officer': 'Officer'
      };
      return labels[this.filter] || 'Option';
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // Pause Download
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    // Resume Download
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);

      await this.continueDownload();
    },

    // Cancel Download
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    // Close Download Modal
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    // Download Current Page (Client-side CSV generation)
    downloadCurrentPage() {
      if (this.billinfoWaiver.length === 0) {
        this.alert.info = true;
        this.message = 'No data available to download';
        return;
      }

      try {
        const csv = this.generateCSV(this.billinfoWaiver);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Waived_Bills_Page_${this.currentPage}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.alert.success = true;
        this.message = `Successfully downloaded ${this.billinfoWaiver.length} records from current page`;
      } catch (error) {
        console.error('Download error:', error);
        this.alert.failed = true;
        this.message = 'Failed to download data: ' + error.message;
      }
    },

    // Generate CSV from data array
    generateCSV(data) {
      if (!data || data.length === 0) return '';

      // Define CSV headers
      const headers = [
        'NO.',
        'Bill No',
        'Fee Description',
        'Description',
        'Sub County',
        'Ward',
        'Zone',
        'Attendant',
        'Waived Amount',
        'Amount Paid',
        'Balance',
        'Status',
        'Date Created'
      ];

      let csv = headers.join(',') + '\n';

      data.forEach((item, index) => {
        const row = [
          index + 1,
          this.escapeCSV(item.billNo),
          this.escapeCSV(item.feeDescription),
          this.escapeCSV(item.description),
          this.escapeCSV(item.subCountyName),
          this.escapeCSV(item.wardName),
          this.escapeCSV(item.zone),
          this.escapeCSV(item.names),
          item.billTotal || 0,
          item.receiptAmount || 0,
          item.billBalance || 0,
          item.status || 'UNPAID',
          this.escapeCSV(item.dateCreated)
        ];
        csv += row.join(',') + '\n';
      });

      return csv;
    },

    // Escape CSV values
    escapeCSV(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return '"' + stringValue.replace(/"/g, '""') + '"';
      }
      return stringValue;
    },

    // Download All Records with Pause/Resume/Retry and Time Estimation
    async downloadAllRecords() {
      if (!this.dateFrom || !this.dateTo) {
        this.alert.info = true;
        this.message = 'Please select date range before downloading';
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} waived bills from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    // Continue Download (used by both initial download and resume)
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchWaivedBillsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allRecordsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    // Fetch Waived Bills Page with Retry Logic
    async fetchWaivedBillsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getWaivedBills");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", "");

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billinfoWaiver || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchWaivedBillsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Download
    async finalizeDownload() {
      if (this.allRecordsData.length > 0) {
        const csv = this.generateCSV(this.allRecordsData);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = `All_Waived_Bills_${this.dateFrom}_to_${this.dateTo}_${moment().format('YYYY-MM-DD_HHmmss')}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.alert.success = true;
        this.message = `Successfully downloaded ${this.allRecordsData.length} waived bills!`;

        this.closeDownloadModal();
      } else {
        this.alert.info = true;
        this.message = 'No records found to download';
        this.closeDownloadModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // API methods
    async getBills(keyword) {
      try {
        this.billinfoWaiver = [];
        this.loading = true;

        const data = new FormData();
        data.append("function", "getWaivedBills");
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
        data.append("status", "UNPAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("keyword", keyword || "");

        const res = await execute(data, biller);
        this.loading = false;

        if (res.data.success) {
          this.billinfoWaiver = res.data.data.billinfoWaiver || [];
          this.summary = res.data.data.summary || { count: 0, total: 0 };
          this.totalPages = Math.ceil(this.summary.count / this.pageSize);
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.loading = false;
        this.message = e.message;
      }
    },

    async getBill(billNo) {
      try {
        this.billNo = billNo;

        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);

        const res = await execute(data, biller);
        if (res.data.success) {
          this.billInfo = res.data.data.billInfo;
          this.billDetail = res.data.data.billDetails;
        } else {
          this.message = res.data.message;
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async revertWaiver(id) {
      if (!confirm("Are you sure you want to revert this waiver? This action cannot be undone.")) {
        return;
      }

      try {
        const data = new FormData();
        data.append("function", "revertWaiver");
        data.append("id", id);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, biller);
        if (res.data.success) {
          this.showAlert('success', 'Waiver reverted successfully');
          this.getBills("");
        } else {
          this.showAlert('failed', res.data.message || "Failed to revert waiver");
        }
      } catch (e) {
        this.showAlert('failed', e.message || "An error occurred while processing your request");
      }
    },

    handleRevertWaiver(id) {
      this.revertWaiver(id);
    },

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetail.billNo
      });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    // Filter data methods
    async getSubCounties() {
      try {
        this.itemList = [];
        const data = new FormData();
        data.append("function", "getSubCounty");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.itemList = res.data.data.map(subCounty => ({
            id: subCounty.subCountyID,
            value: subCounty.subCountyName
          }));
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getWards() {
      try {
        this.itemList = [];
        const data = new FormData();
        data.append("function", "getWards");

        const res = await execute(data, biller);
        if (res.data.success) {
          this.itemList = res.data.data.map(ward => ({
            id: ward.wardID,
            value: ward.wardName
          }));
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getZones() {
      try {
        this.itemList = [];
        const data = new FormData();
        data.append("function", "getZones");

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.itemList = res.data.data.zones.map(zone => ({
            id: zone.id,
            value: zone.zone
          }));
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    async getUsers() {
      try {
        this.itemList = [];
        const data = new FormData();
        data.append("function", "getUsers");

        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.itemList = res.data.data.users.map(user => ({
            id: user.id,
            value: user.names
          }));
        }
      } catch (e) {
        this.message = e.message;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Waived Bills");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    },

    // Pagination methods
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBills("");
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBills("");
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBills("");
      }
    }
  }
}
</script>

<style scoped>
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.toast-container {
  z-index: 9999;
}

.text-warning {
  color: #ffc107 !important;
}

.bg-warning {
  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
}

.table-warning {
  background-color: rgba(255, 193, 7, 0.1);
}

.table-warning th {
  background-color: rgba(255, 193, 7, 0.2) !important;
  color: #856404;
  font-weight: 600;
}

.btn-group .btn {
  white-space: nowrap;
}

.btn-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Progress modal styling */
#downloadProgressModal .modal-body {
  padding: 2rem;
}

#downloadProgressModal .progress {
  background-color: #e9ecef;
}

#downloadProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time remaining display */
.text-muted strong {
  color: #495057;
  font-weight: 600;
}
</style>